import React from 'react'

import { Checkbox, FormControlLabel, FormGroup, TableCell, TableRow } from '@material-ui/core'
import { cloneDeep } from 'lodash'
import PropTypes from 'prop-types'

import { LabeledCheckMark, LabeledX } from './components/Icons'
import SectionTable from './components/SectionTable'
import SkeletonPair from './components/SkeletonPair'

const OtherDetails = ({ isEditing, applicationConfig, setApplicationConfig, loading, getStyle }) => {
  const onUpdateIncludeRaceEthnicity = (newVal) => {
    const updatedState = cloneDeep(applicationConfig)

    setApplicationConfig({
      ...updatedState,
      otherDetails: { ...updatedState?.otherDetails, includeRaceEthnicity: newVal },
    })
  }

  const getReadOnlyView = (isEnabled) =>
    isEnabled ? <LabeledCheckMark enabled={isEnabled} /> : <LabeledX enabled={isEnabled} />
  const renderCheckbox = (value, sectionId, ariaLabel, onChange) => {
    return isEditing ? (
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={value}
              onChange={(e) => onChange(e.target.checked)}
              name={sectionId}
              color="primary"
              label="Include"
              aria-label={ariaLabel ?? 'Include'}
            />
          }
          label="Include"
        />
      </FormGroup>
    ) : (
      getReadOnlyView(value)
    )
  }
  return (
    <SectionTable
      sectionName="Race & Ethnicity"
      showFirstYearHeader={false}
      showTransferHeader={false}
      getStyle={getStyle}
    >
      <TableRow data-testid="include-race-ethnicity-row">
        <TableCell
          align="left"
          variant="body"
          component="th"
          size="small"
        >
          Include Race & Ethnicity details in Application Profile PDFs
        </TableCell>
        <TableCell />
        <TableCell
          align="left"
          size="small"
          data-testid="includeRaceEthnicityCell"
        >
          {loading && <SkeletonPair />}

          {!loading &&
            renderCheckbox(
              applicationConfig.otherDetails?.includeRaceEthnicity,
              'includeRaceEthnicity',
              'include race and ethnicity',
              (newVal) => onUpdateIncludeRaceEthnicity(newVal),
            )}
        </TableCell>
      </TableRow>
    </SectionTable>
  )
}

OtherDetails.propTypes = {
  isEditing: PropTypes.bool.isRequired,
  applicationConfig: PropTypes.object.isRequired,
  setApplicationConfig: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  getStyle: PropTypes.func.isRequired,
}

export default OtherDetails
